import React, { useEffect, useState, forwardRef } from "react";
import { useImmer } from "use-immer";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import OtpInput from 'react-otp-input';
import "bootstrap/dist/css/bootstrap.min.css";
import { BiArrowBack } from "react-icons/bi";
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { useSectionStore, useSubjectStore } from "../../stores";
const fetchIsRemovable = async ({ section, setForm, mode, subject, perm }) => {
    let url;
    mode === 'section' ? url = `/api/admin/delete/sections/${section}` : url = `/api/admin/delete/subjects/${subject}?perm=${perm}`;
    if (mode === 'subject') {
        setForm(draft => {
            draft.loading = false;
            draft.mode = mode;
            draft.subject = subject;
        })
        return;
    }
    const res = await fetch(url);
    if (res.status !== 200) {
        alert(res.statusText);
        return;
    }
    const resJson = await res.json();
    setForm(draft => {
        draft.loading = false;
        draft.mode = mode;
        draft.section = section;
        Object.assign(draft, resJson);
    })
}
const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
        return <div className="timer">Time Up</div>;
    }
    const minutes = Math.floor(remainingTime / 60)
    const seconds = remainingTime % 60

    const time = `${minutes}:${seconds}`;
    return (
        <div className="timer">
            <div className="text">Remaining</div>
            <div className="value">{time}</div>
            <div className="text">seconds</div>
        </div>
    );
};
function DeleteModal({ open, onClose, mode }, ref) {
    const row = ref.current;
    const removeSection = useSectionStore(state => state.removeSection);
    const removeSubject = useSubjectStore(state => state.removeSubject);
    const [form, setForm] = useImmer({ loading: true, message: "", requiresOTP: false, timer: 0, expiry: 0, otp: "", section: "", perm: '0', subject: '' });
    useEffect(() => {
        if (open && row && row._id) {
            fetchIsRemovable({ section: row._id, setForm, mode: mode, perm: form.perm, subject: row._id });
        }
        return () => {
            setForm(draft => void (draft.loading = true));
            ref.current = null;
        }
    }, [open])
    const handleDelete = async () => {
        let url;
        const section = form.section;
        const subject = form.subject;
        form.mode === 'section' ? url = `/api/admin/delete/sections/${section}` : url = `/api/admin/subjects/${subject}?perm=${form.perm}`;
        if (form.requiresOTP) {
            if (!form.otp || form.otp.length < 6) {
                return;
            }
        }
        const res = await fetch(url, {
            method: "delete",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                otp: form.requiresOTP ? form.otp : undefined
            })
        });
        if (res.status !== 200) {
            const error = (await res.json()).message;
            alert(error);
            return;
        }
        const resJson = await res.json();
        alert(resJson.message);
        if (mode == "subject") {
            const subId = form.subject;
            removeSubject(subId);
        }
        if (mode === "section") {
            const secId = form.section;
            removeSection(secId);
        }
        onClose();
    }
    return (
        <>
            <Modal
                show={open}
                onHide={() => onClose()}
                size="lg" centered
                backdrop="static"
                ref={ref}
            >
                <Modal.Header className="modalheader transBlack" closeButton={true} closeVariant="white">
                    <Modal.Title className="modaltitle">
                        Delete Confirmation !
                    </Modal.Title>
                </Modal.Header>
                {form.loading ? <img className="w-50 ms-auto me-auto" alt="loading" src="/images/timer.gif" /> :
                    <Modal.Body>
                        <p style={{ fontFamily: 'Urbanist', fontWeight: "600", fontSize: "1.2rem", textAlign: "center" }}>{form.message}</p>
                        {
                            form.requiresOTP ?
                                <>
                                    <div className="d-flex justify-content-center">
                                        <CountdownCircleTimer
                                            isPlaying
                                            duration={form.timer}
                                            onComplete={() => {
                                                setForm(draft => void (draft.timer = 0))
                                            }}
                                            colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
                                            colorsTime={[10, 6, 3, 0]}
                                        >
                                            {renderTime}
                                        </CountdownCircleTimer>
                                    </div>
                                    <div className="d-flex justify-content-center" style={{ background: "#efe4e4", padding: "2rem 0", borderRadius: "1.75rem" }}>
                                        <OtpInput
                                            inputStyle="otpInputStyle"
                                            disabledStyle={{ background: '#d0e5e4bf' }}
                                            value={form.otp}
                                            isDisabled={form.timer === 0}
                                            onChange={(otp) => setForm(draft => void (draft.otp = otp))}
                                            numInputs={6}
                                            separator={<span>-</span>}
                                        />
                                    </div></> : <></>
                        }
                        {
                            mode === 'subject' ? <div class="form-check" onChange={(e) => setForm(draft => void (draft.perm = e.target.value))}>
                                <input type="radio" value="1" class="btn-check" name="perm" id="perm" autocomplete="off" />
                                <label class="btn btn-primary" style={{ marginRight: "10px" }} for="perm">Delete permanently</label>
                                <input type="radio" value="0" class="btn-check" name="perm" id="perm1" autocomplete="off" checked />
                                <label class="btn btn-primary" for="perm1">Move to previous batch</label>
                            </div>
                                : <></>
                        }
                    </Modal.Body>}
                <Modal.Footer>
                    {form.loading ? <></> : <>
                        <Button variant="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={handleDelete}>
                            Confirm
                        </Button>
                    </>}
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default forwardRef(DeleteModal);
